module.exports = __webpack_public_path__ + "ed486c0b23e6cfeea4d9c8daa60d22c9.png";


//////////////////
// WEBPACK FOOTER
// ./ramastangifs/team.png
// module id = 61
// module chunks = 4